import api from "@/lib/api";

// Voix française intégrée à la tablette : relais quand la voix Gemini n'est pas disponible.
const NAMES = {
  female: ["amélie", "amelie", "audrey", "marie", "virginie", "céline", "celine", "julie", "hortense", "denise", "aurélie", "aurelie", "chantal", "google français", "google francais"],
  male: ["thomas", "nicolas", "paul", "henri", "claude", "daniel", "jacques", "rémy", "remy", "guillaume", "antoine", "mathieu"],
};
const KEY = "passerelle-device-voice";
let fetched = false;

export const deviceGender = () => localStorage.getItem(KEY) || "female";

export function setDeviceGender(g) { localStorage.setItem(KEY, g); }

function refreshGender() {
  if (fetched) return;
  fetched = true;
  api.get("/settings/device-voice").then(({ data }) => setDeviceGender(data.gender)).catch(() => { fetched = false; });
}

function findVoice(fr, gender) {
  for (const name of NAMES[gender]) {
    const found = fr.find((v) => (v.name || "").toLowerCase().includes(name));
    if (found) return found;
  }
  return null;
}

export function pickFrenchVoice(gender = deviceGender()) {
  refreshGender();
  const voices = window.speechSynthesis?.getVoices?.() || [];
  const fr = voices.filter((v) => (v.lang || "").toLowerCase().startsWith("fr"));
  if (fr.length === 0) return null;
  const other = gender === "male" ? "female" : "male";
  const neutral = fr.filter((v) => !findVoice([v], other));
  return findVoice(fr, gender) || neutral.find((v) => (v.lang || "").toLowerCase() === "fr-fr") || neutral[0] || fr[0];
}

// Hauteur de voix : plus grave pour un homme, au cas où l'appareil n'a qu'une voix.
export const devicePitch = (gender = deviceGender()) => (gender === "male" ? 0.85 : 1.05);

export function speakDevice(text, { onStart, onEnd, gender } = {}) {
  if (typeof window === "undefined" || !window.speechSynthesis || !text) return false;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "fr-FR";
  const v = pickFrenchVoice(gender);
  if (v) u.voice = v;
  u.rate = 0.9;
  u.pitch = devicePitch(gender);
  u.onstart = () => onStart?.();
  u.onend = u.onerror = () => onEnd?.();
  window.speechSynthesis.speak(u);
  return true;
}

export function stopDevice() {
  try { window.speechSynthesis?.cancel(); } catch { /* noop */ }
}
